import { useState } from "react";

export default function ResistanceSlider({ onSubmit }) {
  const [value, setValue] = useState(20);

  return (
    <div>
      <label>Resistance: {value}%</label>
      <input
        type="range"
        className="form-range"
        min="0"
        max="100"
        value={value}
        onChange={(e) => setValue(e.target.value)}
      />

      <button
        className="btn btn-success mt-2"
        onClick={() => onSubmit(value)}
      >
        Submit Test
      </button>
    </div>
  );
}